import React, { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../context/LanguageContext";
import "./Companies.css";

const Companies = () => {
  const { language } = useContext(LanguageContext); // Get current language
  const [visible, setVisible] = useState(false); // For fade-in animation on language change

    // Trigger animation on language switch
   useEffect(() => {
    setVisible(false);
    const timeout = setTimeout(() => {
      setVisible(true);
    }, 400);
    return () => clearTimeout(timeout);
  }, [language]);


  // Company data for both languages
  const companies = [
  {
    id: "yaqeen",
    name: language === "ar" ? "يقين المالية" : "Yaqeen Financial",
    description: language === "ar"
      ? "يقين المالية هي شركة رائدة في توفير أفضل المنصات والحلول الذكية للمستثمر الذكي، سواء الأفراد أو الشركات، تحت إشراف هيئة السوق المالية"
      : "Yaqeen Capital is a pioneer in providing top of the line platforms and intelligent solutions for the intelligent investor, both individual and corporate, under the supervision of the CMA.",
    logo: "/imgs/yaqeen.jpg",
    link: "https://yaqeen.sa/ar/"
  },
  {
    id: "nayifat",
    name: language === "ar" ? "شركة النايفات للتمويل" : "Nayifat Finance Company",
    description: language === "ar"
      ? "تهدف النايفات إلى دعم عملائها بمجموعة متنوعة من حلول التمويل المتوافقة مع الشريعة الإسلامية لتناسب كل حاجة، وفقًا لقانون شركات التمويل، تحت إشراف مؤسسة النقد العربي السعودي"
      : "Nayifat aims to support its clients with a variety of Sharia-compliant financing solutions to fit every need, following the Law of Finance Companies, under the supervision of SAMA.",
    logo: "/imgs/nayifat_logo.svg",
    link: "https://nayifat.com/"
  },
  {
    id: "alamthal",
    name: language === "ar" ? "شركة الأمثل للتمويل" : "Alamthal Financing",
    description: language === "ar"
      ? "توفر شركة الأمثل للتمويل بشكل أساسي تأجير وتمويل معدات التجار والمركبات، وفقًا لقانون شركات التمويل تحت إشراف مؤسسة النقد العربي السعودي"
      : "Al Amthal Financing Company principally provides the leasing and financing of dealer equipment and vehicles, following the Law of Finance Companies, under the supervision of SAMA.",
    logo: "/imgs/alamthal_logo.svg",
    link: "https://www.al-amthal.com.sa/"
  }
];


  return (
  <div className={`companies-page ${visible ? "fade-in" : "fade-out"}`}
   dir={language === "ar" ? "rtl" : "ltr"}>

     {/* Section title */}
      <h2 className="companies-title">
        {language === "ar" ? "شركاتنا" : "Our Companies"}
      </h2>

      {/* Companies grid */}
      <div className="companies-grid">
        {companies.map((company, index) => (
          <div className="company-card" key={index}>
          <img
           src={company.logo}
          alt={company.name}
          className={`company-logo 
            ${company.id === "fal" ? "fal-logo" : ""} 
            ${company.id === "nayifat" ? "nayifat-logo" : ""}`}
            />
          
           {/* Company name and description */}
            <div className="company-content">
                <h3>{company.name}</h3>
                <p>{company.description}</p>
                </div>

           {/* Visit button */}
                <a
                href={company.link}
                className="visit-button"
                target="_blank"
                rel="noopener noreferrer"
                >
                  {language === "ar" ? "زيارة" : "Visit"}
                  </a>
              </div>
           ))}
       </div>
    </div>
  );
};

export default Companies;
